import { Dispatch, Action, ActionCreator } from "redux";
import { ThunkAction } from "redux-thunk";

import { SalesActivityModuleState } from "../../..";

export enum VendorPartnerActionTypes {
	SHOW_VENDOR_PARTNER_LOADER = "SHOW_VENDOR_PARTNER_LOADER",
	HIDE_VENDOR_PARTNER_LOADER = "HIDE_VENDOR_PARTNER_LOADER",
	OPEN_EDIT_VENDOR_PARTNER_DRAWER = "OPEN_EDIT_VENDOR_PARTNER_DRAWER",
	CLOSE_EDIT_VENDOR_PARTNER_DRAWER = "CLOSE_EDIT_VENDOR_PARTNER_DRAWER"
}

export type ShowVendorPartnerLoaderAction =
	Action<VendorPartnerActionTypes.SHOW_VENDOR_PARTNER_LOADER>;
export type HideVendorPartnerLoaderAction =
	Action<VendorPartnerActionTypes.HIDE_VENDOR_PARTNER_LOADER>;

export type OpenEditVendorPartnerDrawerAction =
	Action<VendorPartnerActionTypes.OPEN_EDIT_VENDOR_PARTNER_DRAWER>;
export type CloseEditVendorPartnerDrawerAction =
	Action<VendorPartnerActionTypes.CLOSE_EDIT_VENDOR_PARTNER_DRAWER>;

export type VendorPartnerActions =
	| ShowVendorPartnerLoaderAction
	| HideVendorPartnerLoaderAction
	| OpenEditVendorPartnerDrawerAction
	| CloseEditVendorPartnerDrawerAction;

export interface VendorPartnerDispatch {
	showVendorPartnerLoader: ActionCreator<
		ThunkAction<
			ShowVendorPartnerLoaderAction,
			SalesActivityModuleState,
			null,
			ShowVendorPartnerLoaderAction
		>
	>;
	hideVendorPartnerLoader: ActionCreator<
		ThunkAction<
			HideVendorPartnerLoaderAction,
			SalesActivityModuleState,
			null,
			HideVendorPartnerLoaderAction
		>
	>;
	openEditVendorPartnerDrawer: ActionCreator<
		ThunkAction<
			OpenEditVendorPartnerDrawerAction,
			SalesActivityModuleState,
			null,
			OpenEditVendorPartnerDrawerAction
		>
	>;
	closeEditVendorPartnerDrawer: ActionCreator<
		ThunkAction<
			CloseEditVendorPartnerDrawerAction,
			SalesActivityModuleState,
			null,
			CloseEditVendorPartnerDrawerAction
		>
	>;
}

export const VendorPartnerActionCreators: VendorPartnerDispatch = {
	showVendorPartnerLoader: () => {
		return (dispatch: Dispatch): ShowVendorPartnerLoaderAction => {
			const showVendorOpportunityLoaderAction: ShowVendorPartnerLoaderAction =
				{
					type: VendorPartnerActionTypes.SHOW_VENDOR_PARTNER_LOADER
				};
			return dispatch(showVendorOpportunityLoaderAction);
		};
	},
	hideVendorPartnerLoader: () => {
		return (dispatch: Dispatch): HideVendorPartnerLoaderAction => {
			const hideVendorOpportunityLoaderAction: HideVendorPartnerLoaderAction =
				{
					type: VendorPartnerActionTypes.HIDE_VENDOR_PARTNER_LOADER
				};
			return dispatch(hideVendorOpportunityLoaderAction);
		};
	},
	openEditVendorPartnerDrawer: () => {
		return (dispatch: Dispatch): OpenEditVendorPartnerDrawerAction => {
			const openOpportunityDrawerAction: OpenEditVendorPartnerDrawerAction =
				{
					type: VendorPartnerActionTypes.OPEN_EDIT_VENDOR_PARTNER_DRAWER
				};
			return dispatch(openOpportunityDrawerAction);
		};
	},
	closeEditVendorPartnerDrawer: () => {
		return (dispatch: Dispatch): CloseEditVendorPartnerDrawerAction => {
			const closeOpportunityDrawerAction: CloseEditVendorPartnerDrawerAction =
				{
					type: VendorPartnerActionTypes.CLOSE_EDIT_VENDOR_PARTNER_DRAWER
				};
			return dispatch(closeOpportunityDrawerAction);
		};
	}
};

export default VendorPartnerActionCreators;
